export default "__VITE_ASSET__CXjc947n__"